import { documentReady } from './utils';
import $ from 'jquery';

const Modals = {
    initialize: () => {
        documentReady(() => {
            Modals.initModals();
        });
    },

    initModals: () => {
        $('.popup-modal').magnificPopup({
            type: 'inline'
        });
        
        $(document).on('click', '.popup-modal-dismiss', function (e) {
            e.preventDefault();
            $.magnificPopup.close();
        });   
    }
}

Modals.initialize();

export default Modals;
